<template>
    <bank-cards-get
        :params="{
            page
        }"
        v-slot="{
            data: cards,
            meta,
            error,
            is_loading,
            has_loaded,
            get
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="get"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center px-4 border-b h-18 sm:px-6">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Bank Cards</h1>
                    </div>
                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full fill-current text-grey"
                        />
                    </div>
                    <router-link
                        :to="{ name: $router.fix('dashboard.*.bank-cards.create') }"
                        class="btn btn-blue btn-with-icon"
                    >
                        <div class="flex items-center w-full h-full">
                            <base-svg
                                name="icon-add-circle"
                                class="w-6 h-6 md:mr-2"
                            />

                            <span class="hidden md:inline">New Card</span>
                        </div>
                    </router-link>
                </header>

                <template v-if="meta.count > 0">
                    <with-dimensions
                        v-slot="{
                            width
                        }"
                    >
                        <table-ish>
                            <table-ish-row-router-link
                                v-for="card in cards"
                                :key="card.uuid"
                                :to="{
                                    name: $router.fix('dashboard.*.bank-cards.show'),
                                    params: {
                                        card: card.uuid
                                    }
                                }"
                            >
                                <table-ish-cell>
                                    <truncate-hack>
                                        **** **** **** {{ card.last_four }}
                                    </truncate-hack>

                                    <template slot="secondary">
                                        {{ card.exp_month }} / {{ card.exp_year }}

                                        <span class="ml-3 uppercase">{{ card.brand }}</span>
                                    </template>
                                </table-ish-cell>

                                <table-ish-cell
                                    :shrink="true"
                                    class="text-right"
                                >
                                    <span
                                        v-if="card.is_default"
                                        class="font-semibold rounded-full bg-green-lighter text-green-darker"
                                        :class="width > 500 ? 'text-sm px-3 py-1' : 'text-xs px-2 leading-none'"
                                    >
                                        Default
                                    </span>

                                    <span
                                        v-if="!card.has_three_d_secure_support"
                                        class="font-semibold rounded-full bg-red-lighter text-red-darker"
                                        :class="width > 500 ? 'text-sm px-3 py-1' : 'text-xs px-2 leading-none'"
                                    >
                                        Unsupported
                                    </span>

                                    <span
                                        v-else-if="!card.is_verified"
                                        class="font-semibold rounded-full bg-yellow-lighter text-yellow-darker"
                                        :class="width > 500 ? 'text-sm px-3 py-1' : 'text-xs px-2 leading-none'"
                                    >
                                        Requires confirmation
                                    </span>
                                </table-ish-cell>
                            </table-ish-row-router-link>
                        </table-ish>
                    </with-dimensions>

                    <footer class="px-4 text-sm font-semibold rounded-b bg-grey-bg sm:px-6 text-grey-darker">
                        <base-pagination
                            v-model="page"
                            :per-page="meta.per_page"
                            :from="meta.from"
                            :to="meta.to"
                            :last-page="meta.last_page"
                            :count="meta.count"
                            :total="meta.total"
                            :is-disabled="is_loading"
                        />
                    </footer>
                </template>

                <div
                    v-else
                    class="relative py-16"
                >
                    <div class="max-w-sm px-6 mx-auto text-center">
                        <h2 class="mb-2 text-xl font-semibold">
                            Add your first bank card
                        </h2>

                        <div class="text-base text-grey-darker">
                            <p>You haven't added a card yet.</p>
                            <p class="md:hidden">
                                Tap <!--
                                --><base-svg
                                    name="icon-add-circle"
                                    class="inline w-4 h-4 -mt-1"
                                /><!--
                                --> above to get started.
                            </p>
                            <p class="hidden md:block">
                                Click "<!--
                                --><base-svg
                                    name="icon-add-circle"
                                    class="inline w-4 h-4 -mt-1"
                                /><!--
                                --> New Card" above to get started.
                            </p>
                        </div>
                    </div>

                    <base-svg
                        name="misc-arrow-up"
                        class="absolute top-0 right-0 w-4 mt-3 mr-8 sm:mr-10 md:mr-20 md:w-5 md:mt-4 fill-primary-blue-light"
                    />
                </div>
            </div>
        </div>
    </bank-cards-get>
</template>

<script>
    import BankCardsGet from '../../../../components/bank-cards-get'
    import PaginationMixin from '../../../../mixins/pagination'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            BankCardsGet
        }
    }
</script>
